import { useAtom } from 'jotai';
import { useCallback, useState } from 'react';

import { useCampaignsService } from '@/src/infrastructure/Protocol/Campaigns/useCampaignsService';
import { IStrategy } from '@/src/modules/CampaignsModule/interfaces/Campaigns';

import { atomStrategyList } from '@/modules/CampaignsModule/atoms/campaignAtom';

export const useStrategies = () => {
  const service = useCampaignsService();
  const [loading, setLoading] = useState<boolean>(false);
  const [, setStrategyList] = useAtom(atomStrategyList);

  const getStrategies = useCallback(async () => {
    setLoading(true);

    const { strategies } = await service.getStrategiesByAccount();
    setStrategyList((strategies as IStrategy[]) ?? []);

    setLoading(false);
  }, [service, setStrategyList]);

  return { getStrategies, loading };
};
